import { render, staticRenderFns } from "./useraffiliate.vue?vue&type=template&id=64de6e60&"
import script from "./useraffiliate.vue?vue&type=script&lang=js&"
export * from "./useraffiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports